export default function selfOrClosest(element, selector) {
  return element.matches(selector) && element || element.closest(selector)
}
